import { useQuery } from '@tanstack/react-query'

import { bookKeys } from '../../../../data/queryFactories'
import { bookService } from '../../../../service/BookService'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { convertUnixToDate } from '../../../../utils/conversion'
function mapBookByUuidData(data) {
  return {
    uuid: data?.uuid ?? '',
    author: data?.author ?? '',
    cover: data?.imageUrl ?? '',
    description: data?.description ?? '',
    faculty: data?.facultyUuid ?? '',
    fileSize: data?.fileSize ?? '',
    isbn: data?.isbn ?? '',
    major: data?.major ?? '',
    pages: data?.pages ?? '',
    price: data?.price ?? '',
    publishYear: data?.publishYear ?? '',
    publisher: data?.publisher ?? '',
    statusName: data?.statusName ?? '',
    subject: data?.subject ?? '',
    title: data?.title ?? '',
    token: data?.token ?? '',
    typename: data?.typename ?? '',
    uploadDate: convertUnixToDate(data?.createdAt),
    uploader: data?.createdBy ?? '',
    readieEnabled: data?.readieEnabled ?? '',
    bookUrl: data?.bookUrl ?? '',
    bookCollections: data?.bookCollections ?? [],
    borrowInfo: data.borrow ? data?.borrowInfo : null,
    borrow: data?.borrow ?? null,
  }
}
export default function useGetBookByUUID(uuid) {
  const { data, isLoading, error } = useQuery({
    queryKey: bookKeys.detail(uuid),
    queryFn: async () => {
      const { success, message } = await bookService.getByUuid(uuid)

      if (!success) {
        throw new Error('Lỗi: Không thể lấy dữ liệu sách')
      }
      const bookData = message?.content
      if (bookData) {
        return mapBookByUuidData(bookData)
      }
      throw new Error('Không xác định')
    },
  })
  if ((error || !data) && !isLoading) {
    showErrorToast({
      error: error.message || 'Lỗi không xác định',
      message: 'Lấy thông tin thất bại, vui lòng liên hệ admin',
    })
  }
  return { data, isLoading }
}
